import React, { useState } from "react";

const SliderNavigation = ({ slider, section }) => {
  const [isPlaying, setIsPlaying] = useState(true);

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  const play = () => {
    slider.current.slickPlay();
  };
  const pause = () => {
    slider.current.slickPause();
  };

  // const handlePlayPause = () => {
  //   setIsPlaying((prev) => !prev);
  //   if (isPlaying) {
  //     play();
  //   } else {
  //     pause();
  //   }
  // };

  const handlePlayPause = () => {
    setIsPlaying((prev) => {
      if (prev) {
        pause();
      } else {
        play();
      }
      return !prev;
    });
  };
  return (
    <div className="owl-nav mt-2">
      <div className="arrow">
        <button
          className="left"
          onClick={prev}
          aria-label={`Previous ${section} item`}
        >
          <i className="fa fa-angle-left"></i>
        </button>

        <button
          className="play-pause"
          onClick={handlePlayPause}
          aria-label={
            isPlaying ? `Pause ${section} item` : `Play ${section} item`
          }
        >
          <i className={`fa ${!isPlaying ? "fa-play" : "fa-pause"}`}></i>
        </button>

        <button
          className="right"
          onClick={next}
          aria-label={`Next ${section} item`}
        >
          <i className="fa fa-angle-right"></i>
        </button>
      </div>
    </div>
  );
};

export default SliderNavigation;
